import { PUBLIC_HOST } from '@config/index';

const openGraphUrlCreator = (asPath: string, locale?: string) => {
  if (locale === 'pl') {
    return PUBLIC_HOST + asPath;
  }
  return `${PUBLIC_HOST}/${locale + asPath}`;
};

export default openGraphUrlCreator;
